import axios from 'axios'

// const baseURL = "http://127.0.0.1:8000/api/"
const baseURL = "https://admin.gb-skillscentre.optimalonline.co.za/api/"

export default axios.create({
    baseURL
})